import { render, staticRenderFns } from "./SwollenLymphNodes.vue?vue&type=template&id=056bb5d4&scoped=true"
import script from "./SwollenLymphNodes.vue?vue&type=script&lang=js"
export * from "./SwollenLymphNodes.vue?vue&type=script&lang=js"
import style0 from "./SwollenLymphNodes.vue?vue&type=style&index=0&id=056bb5d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056bb5d4",
  null
  
)

export default component.exports